import { render, staticRenderFns } from "./SelectEntitiesFacebook.vue?vue&type=template&id=052540c2&scoped=true&"
import script from "./SelectEntitiesFacebook.vue?vue&type=script&lang=ts&"
export * from "./SelectEntitiesFacebook.vue?vue&type=script&lang=ts&"
import style0 from "./SelectEntitiesFacebook.vue?vue&type=style&index=0&id=052540c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052540c2",
  null
  
)

export default component.exports